import GoogleMap from "./GoogleMap";

export default function Contact() {

  return (
    <>
      <section
        id="contact"
        className="contact-area after-none contact-bg pt-5 pb-4 p-relative fix"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 order-1">
              <div className="contact-info">
                <div
                  className="single-cta pb-4 mb-4 wow fadeInUp animated"
                  data-animation="fadeInDown animated"
                  data-delay=".2s"
                >
                  <div className="f-cta-icon">
                    <i
                      className="far fa-map"
                      style={{
                        backgroundColor: "hsl(136,61%,26%)",
                        color: "hsl(47,99%,54%)",
                      }}
                    ></i>
                  </div>
                  <h5>Adres</h5>
                  <p>
                    Podgórze 55, <br />
                    57-340 Duszniki-Zdrój
                  </p>
                </div>
                <div
                  className="single-cta pb-4 mb-4 wow fadeInUp animated"
                  data-animation="fadeInDown animated"
                  data-delay=".2s"
                >
                  <div className="f-cta-icon">
                    <i
                      className="far fa-envelope-open"
                      style={{
                        backgroundColor: "hsl(136,61%,26%)",
                        color: "hsl(47,99%,54%)",
                      }}
                    ></i>
                  </div>
                  <h5>E-mail</h5>
                  <p>slonecznepodgorze@gmail.com</p>
                </div>
              </div>
            </div>
            <div className="col-lg-8 order-2">
              <GoogleMap
                id="map"
                style={{
                  width: "100%",
                  aspectRatio: "1.62/ 1",
                  backgroundColor: "white",
                }}
              >
              </GoogleMap>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
